(function(){
  var root=document.querySelector('[data-rw-spin]'); if(!root||root._rw)return; root._rw=true;
  var stage=root.querySelector('.rw-spin__stage');
  var panel=root.querySelector('.rw-spin__panel');
  var data; try{data=JSON.parse(root.querySelector('[data-rw-products]').textContent)}catch(e){data=[]}
  data=data.filter(function(p){return p&&p.img});
  /* PINNED BS3PACK (2026-09-22): the section prepends a synthetic combo item carrying "bs3":true and a "combo"
     array of three tee images. De-dupe by handle so the same bundle appearing inside the collection cannot produce
     a second slot — the pinned copy is first, so it wins and the spinner always opens on it (pos starts at 0). */
  (function(){
    var seenH={},out=[],i,h;
    for(i=0;i<data.length;i++){h=data[i].handle||data[i].url||('i'+i);if(seenH[h])continue;seenH[h]=1;out.push(data[i])}
    data=out;
  })();
  /* PRE-CUT TEES (2026-09-17): every tee in the collection has a server-side alpha cutout on the Shopify CDN at
     files/spin-<handle>.png (2px alpha erosion + edge defringe — kills the white JPEG halo the in-browser flood-fill
     left behind). The slot uses that PNG directly and skips the canvas cutout. If a PNG is missing (a tee added
     after the batch), the img 404s and the slot falls back to the original image + browser cutout automatically. */
  var PNG_BASE='https://cdn.shopify.com/s/files/1/2248/8635/files/spin-';
  /* Bump PNG_VER whenever a spin-*.png is replaced in Files: the CDN caches every resized variant (per browser Accept
     header) for a year and fileUpdate does not purge them, so a new version string is the only reliable cache-bust. */
  var PNG_VER='2';
  function pngFor(p){
    if(p.combo)return null;
    if(p._png!==undefined)return p._png;
    var m=String(p.url||'').match(/\/products\/([^\/?#]+)/);
    /* ?width=1100 lets the CDN resize + auto-WebP (alpha kept): ~54KB per tee vs 0.5-1.1MB for the raw PNG master. */
    p._png=m?PNG_BASE+m[1]+'.png?width=1100&v='+PNG_VER:null; return p._png;
  }
  var N=data.length; if(!N){root.querySelector('.rw-spin__hint').textContent='No products in this collection yet';return;}
  var DWELL=parseInt(root.dataset.dwell,10)||3000;
  var BS3_LABEL=root.dataset.rwBs3Label||'Best Seller 3 Pack';
  /* The Best Seller 3 Pack is ONE cart line carrying THREE shirts, so the bundle tracker has to weight it or a
     customer who buys the pack sees 1 of 5 tees lit and believes they have unlocked nothing. Handle comes from the
     section when present; the literal is the fallback so the tracker is correct even on an un-updated section. */
  var BS3_HANDLE=(root.dataset.rwBs3Handle||'best-seller-3-pack-tee-bundle').toLowerCase();
  var BS3_UNITS=parseInt(root.dataset.rwBs3Units,10)||3;
  var DEBUG=/[?&]rwdebug=1/.test(location.search), dbgEl=root.querySelector('.rw-spin__hint');
  function dbg(m){if(!DEBUG)return;dbgEl.textContent='DEBUG: '+m;dbgEl.style.cssText+=';color:#B01C2E!important;opacity:1!important;background:#fff;padding:8px 12px;letter-spacing:.05em;text-transform:none;font-size:12px;position:relative;z-index:50'}
  window.addEventListener('error',function(e){dbg('js error: '+e.message)});
  var SLOTS=9, HALF=4, FRICTION=1.55, MAXV=22, SNAPV=0.9;
  /* Wobble finish: a fling that travels WOBBLE_MIN+ tees ends by rocking between the two tees it is settling between,
     the swing shrinking each pass, then lands on one of them at random and the dwell starts from there. */
  var WOBBLE_MIN=10, WOBBLE_DUR=1.6, WOBBLE_CYCLES=2.5;
  var flingStart=0, wobS=0, wobO=0, wobF=0, wobT=0, wobFrom=0;
  var slots=[],k,REF=null;
  for(k=0;k<SLOTS;k++){
    var f=document.createElement('figure'); f.className='rw-spin__slot'; f.setAttribute('role','img');
    var im=document.createElement('img'); im.crossOrigin='anonymous'; im.decoding='async'; im.draggable=false; im.alt='';
    f.appendChild(im); f.img=im; f._idx=-1; f._v=null;
    var bnew=document.createElement('span'); bnew.className='rw-spin__badge-new'; bnew.textContent='New'; f.appendChild(bnew);
    var bltd=document.createElement('span'); bltd.className='rw-spin__badge-ltd'; bltd.textContent='Limited Time Design'; f.appendChild(bltd);
    var bbs3=document.createElement('span'); bbs3.className='rw-spin__badge-bs3'; bbs3.textContent=BS3_LABEL; f.appendChild(bbs3);
    stage.appendChild(f); slots.push(f);
  }
  var pos=0,vel=0,mode='idle',target=0,dragging=false,paused=false,lastT=0,samples=[],dwellTimer=null;
  /* No dwell/zoom until the visitor has spun (drag, slot tap, or arrow key) — the page loads at rest with no timer. */
  var spun=false;
  var itemW=280,spacing=170,downX=0,downY=0,moved=false,downSlot=null;
  function mod(a,n){return ((a%n)+n)%n}
  function measure(){itemW=slots[0].offsetWidth||280;spacing=itemW*0.72}
  /* ---- combo slot: three tees rendered inside one slot (pinned BS3Pack item) ----
     Each tee lives in its own <span> cell so a cutout <canvas> can sit beside the <img> without disturbing the
     layout. A cell source flagged in p.comboCut is a raw white-background photo (a colourway / front-back override)
     and is run through the cutout in HARD mode — see cutout() for why the ordinary mode is not enough here. */
  var comboCarriers={};
  function comboCut(src,cb){
    if(!src)return;
    var o=comboCarriers[src]||(comboCarriers[src]={img:src,title:'combo cell'});
    if(o._cutFail)return;
    cutout(o,cb,true);
  }
  function comboHost(slot){
    if(slot._combo)return slot._combo;
    var d=document.createElement('div'); d.className='rw-spin__combo';
    for(var i=0;i<3;i++){
      var cell=document.createElement('span');
      var c=document.createElement('img'); c.decoding='async'; c.draggable=false; c.alt='';
      cell.appendChild(c); d.appendChild(cell);
    }
    slot.appendChild(d); slot._combo=d; return d;
  }
  function paintCombo(slot,p){
    var d=comboHost(slot), cells=d.children, i;
    d.style.display='';
    for(i=0;i<3;i++){
      (function(cell,j){
        var el=cell.querySelector('img');
        var src=(p.combo||[])[j]||'';
        var needCut=!!((p.comboCut||[])[j]);
        var stale=cell.querySelector('canvas'); if(stale)stale.remove();
        cell.classList.remove('is-cut');
        el.onerror=function(){
          var raw=(p.comboRaw||[])[j];
          el.onerror=null;
          if(raw&&el.getAttribute('src')!==raw){el.src=raw;comboCut(raw,function(cv){place(cell,cv)})}
          else{dbg('combo image '+(j+1)+' unavailable')}
        };
        if(el.getAttribute('src')!==src)el.src=src;
        if(needCut&&src)comboCut(src,function(cv){place(cell,cv)});
      })(cells[i],i);
    }
    function place(cell,cv){
      if(!cell.isConnected)return;
      var old=cell.querySelector('canvas'); if(old)old.remove();
      /* the cached canvas is shared across slots, so clone it rather than moving the original out of another cell */
      var copy=document.createElement('canvas'); copy.width=cv.width; copy.height=cv.height;
      try{copy.getContext('2d').drawImage(cv,0,0)}catch(e){return}
      cell.appendChild(copy); cell.classList.add('is-cut');
    }
  }
  function assign(slot,v){
    if(slot._v===v)return; slot._v=v;
    var idx=mod(v,N); if(slot._idx!==idx){
      slot._idx=idx; var p=data[idx];
      slot.setAttribute('aria-label',p.title);
      var tg=(p.tags||[]).map(function(t){return String(t).toLowerCase()});
      var nd=parseFloat(root.dataset.rwNewDays||'14');
      var fresh=nd>0&&p.pub>0&&(Date.now()-p.pub*1000)<nd*86400000;
      slot.classList.toggle('has-new',tg.indexOf('new')>-1||fresh);
      slot.classList.toggle('has-ltd',tg.indexOf('ltd')>-1);
      slot.classList.toggle('has-bs3',!!p.bs3);
      slot.classList.toggle('is-combo',!!p.combo);
      var old=slot.querySelector('canvas'); if(old&&old!==p._cut&&!old.closest('.rw-spin__combo'))old.remove();
      if(p.combo){
        /* The single <img> is kept loaded (and hidden by CSS) purely so dominant() can sample the bundle art for
           the zoom background; the three visible tees live in the combo wrapper. */
        slot.classList.remove('is-cut'); slot.classList.remove('is-raw');
        slot.img.onerror=null; if(p.img)slot.img.src=p.img;
        paintCombo(slot,p);
        return;
      }
      if(slot._combo)slot._combo.style.display='none';
      var png=(!p._pngFail)?pngFor(p):null;
      slot.img.onerror=null;
      slot.img.src=png||p.img;
      if(png){
        slot.classList.remove('is-cut');slot.classList.remove('is-raw');
        slot.img.onerror=function(){
          if(slot._idx!==idx||p._pngFail)return;
          p._pngFail=true; dbg('pre-cut PNG missing, using browser cutout: '+p.title);
          slot._idx=-1; slot._v=null; assign(slot,v);
        };
      }else if(p._cut){slot.appendChild(p._cut);slot.classList.add('is-cut');slot.classList.remove('is-raw')}
      else{slot.classList.remove('is-cut');slot.classList.add('is-raw');
        if(!p._cutFail)cutout(p,function(cv){if(slot._idx===idx){slot.appendChild(cv);slot.classList.add('is-cut');slot.classList.remove('is-raw')}})}
    }
  }
  /* HARD MODE (2026-09-22): the ordinary cutout clears pure white and ramps alpha on the single ring of pixels
     touching it. On a raw product JPEG that is not enough — chroma subsampling leaves a band of near-white pixels
     just under the white threshold all the way around the garment, which survives as the dotted white outline.
     Hard mode is what the server-side spin-*.png batch does: catch near-white as background too (236 vs 244),
     DILATE the background mask 2px so the mask eats into the garment edge rather than stopping short, then ramp
     alpha across a much wider band (170-236 vs 204-240). Costs two extra passes over the bitmap, applied only to
     combo override cells; the single-tee fallback path still uses the gentler original settings. */
  function cutout(p,cb,hard){
    if(p._cut){cb(p._cut);return} if(p._cutting){(p._cbs=p._cbs||[]).push(cb);return}
    p._cutting=true;p._cbs=[cb];
    var im=new Image();im.crossOrigin='anonymous';
    im.onload=function(){
      try{
        var MAXPX=(window.devicePixelRatio||1)>1?1100:800;
        var W=im.naturalWidth,H=im.naturalHeight,S=Math.min(1,MAXPX/Math.max(W,H)),w=Math.round(W*S),h=Math.round(H*S);
        var c=document.createElement('canvas');c.width=w;c.height=h;
        var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(im,0,0,w,h);
        var id=x.getImageData(0,0,w,h),d=id.data,n=w*h,vis=new Uint8Array(n),q=new Int32Array(n),qh=0,qt=0,i,o,mn;
        var WT=hard?236:244, DFLO=hard?170:204, DFHI=hard?236:240, DFR=DFHI-DFLO, ERODE=hard?2:0;
        function isW(i){o=i*4;return Math.min(d[o],d[o+1],d[o+2])>=WT}
        function push(i){if(!vis[i]&&isW(i)){vis[i]=1;q[qt++]=i}}
        for(i=0;i<w;i++){push(i);push((h-1)*w+i)}
        for(i=0;i<h;i++){push(i*w);push(i*w+w-1)}
        while(qh<qt){i=q[qh++];var xi=i%w;if(xi>0)push(i-1);if(xi<w-1)push(i+1);if(i>=w)push(i-w);if(i+w<n)push(i+w)}
        var cx=w>>1,cy=h>>1,hit=0;for(i=-6;i<=6;i++)for(var j=-6;j<=6;j++)if(vis[(cy+j)*w+cx+i])hit++;
        var frac=qt/n, leaked=hit>0||frac>0.9;
        if(leaked){p._cutFail=true;p._cutting=false;dbg('cutout leaked, using blend fallback: '+p.title);return}
        /* dilate the background mask so it bites INTO the garment edge, killing the compression halo */
        var pass,grow,gi,gn,xg;
        for(pass=0;pass<ERODE;pass++){
          grow=[];
          for(i=0;i<n;i++){
            if(vis[i])continue;
            xg=i%w;
            if((xg>0&&vis[i-1])||(xg<w-1&&vis[i+1])||(i>=w&&vis[i-w])||(i+w<n&&vis[i+w]))grow.push(i);
          }
          for(gi=0,gn=grow.length;gi<gn;gi++)vis[grow[gi]]=1;
        }
        for(i=0;i<n;i++){
          o=i*4;
          if(vis[i]){d[o+3]=0;continue}
          var xi2=i%w, edge=(xi2>0&&vis[i-1])||(xi2<w-1&&vis[i+1])||(i>=w&&vis[i-w])||(i+w<n&&vis[i+w]);
          if(edge){mn=Math.min(d[o],d[o+1],d[o+2]);if(mn>DFLO)d[o+3]=Math.round(Math.max(0,Math.min(1,(DFHI-mn)/DFR))*255)}
        }
        artColor(p,d,n,vis);
        x.putImageData(id,0,0);
        p._cut=c;p._cutting=false;
        (p._cbs||[]).forEach(function(f){f(c)});p._cbs=null;
      }catch(e){p._cutFail=true;p._cutting=false;dbg('cutout error: '+(e&&e.message||e))}
    };
    im.onerror=function(){p._cutFail=true;p._cutting=false;dbg('image load failed: '+p.img)};
    im.src=p.img;
  }
  var plate=root.querySelector('[data-rw-plate]'), glowIdx=-1;
  /* dwell bar under the hem: solid black, LOADING…, crimson fill that tracks the dwell (CSS-driven off .is-dwelling) */
  plate.innerHTML='<i></i><span>Loading\u2026</span>';
  function render(t){
    if(paused)return;
    var base=Math.round(pos);
    var lean=Math.max(-14,Math.min(14,vel*1.4));
    for(var v=base-HALF;v<=base+HALF;v++){
      var slot=slots[mod(v,SLOTS)]; assign(slot,v);
      var rel=v-pos, a=Math.abs(rel);
      var op=a>2.6?Math.max(0,1-(a-2.6)/1.1):1;
      var bob=Math.sin(t/720+v*1.3)*itemW*0.012;
      var x=rel*spacing, y=a*a*itemW*0.03+bob, z=-a*a*150;
      var ry=-rel*26, rz=rel*5+lean, sc=Math.max(.6,1-a*0.05);
      slot.style.opacity=op;
      slot.style.transform='translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,'+z.toFixed(1)+'px) rotateY('+ry.toFixed(2)+'deg) rotateZ('+rz.toFixed(2)+'deg) scale('+sc.toFixed(3)+')';
      slot.style.zIndex=100-Math.round(a*10);
      var bl=Math.abs(vel)>5?Math.min(2.5,(Math.abs(vel)-5)*0.3):0; slot.style.filter=bl?'blur('+bl.toFixed(2)+'px)':'';
    }
  }
  function setGlow(){
    var hero=slots[mod(Math.round(pos),SLOTS)]; if(!hero||hero._idx<0||hero._idx===glowIdx)return;
    var p=data[hero._idx]; if(!p._color&&!(hero.img.complete&&hero.img.naturalWidth))return;
    glowIdx=hero._idx; var col=dominant(hero.img,p); if(col)root.style.setProperty('--rw-glow',col);
  }
  function frame(t){
    var dt=lastT?Math.min(.05,(t-lastT)/1000):0; lastT=t;
    if(!dragging&&!paused){
      if(mode==='free'){
        vel*=Math.exp(-FRICTION*dt); pos+=vel*dt;
        if(Math.abs(vel)<SNAPV){
          if(Math.abs(pos-flingStart)>=WOBBLE_MIN){
            wobS=Math.round(pos+vel*0.35); wobO=wobS+(vel<0?-1:1); wobF=Math.random()<0.5?0:1; wobT=0; wobFrom=pos; vel=0; mode='wobble';
          }else{target=Math.round(pos+vel*0.35);mode='snap'}
        }
      }else if(mode==='wobble'){
        wobT+=dt; var w=Math.min(1,wobT/WOBBLE_DUR);
        var g=(1-w)*0.5*(1-Math.cos(w*Math.PI*2*WOBBLE_CYCLES))+w*wobF;
        var want=wobS+(wobO-wobS)*g, ease=Math.min(1,wobT/0.15);
        pos=wobFrom+(want-wobFrom)*ease; vel=0;
        if(w>=1){pos=wobS+(wobO-wobS)*wobF;mode='idle';startDwell()}
      }else if(mode==='snap'){
        var d=target-pos; pos+=d*Math.min(1,9*dt); vel=0;
        if(Math.abs(d)<0.002){pos=target;mode='idle';startDwell()}
      }
    }
    render(t); requestAnimationFrame(frame);
  }
  function clearDwell(){if(dwellTimer){clearTimeout(dwellTimer);dwellTimer=null}root.classList.remove('is-dwelling')}
  function startDwell(){
    if(!spun)return;
    clearDwell(); setGlow();
    void root.offsetWidth; root.classList.add('is-dwelling');
    dwellTimer=setTimeout(zoom,DWELL);
  }
  /* Matches the PDP treatment: coloured stars (theme --color-rating) followed by the review count only. */
  function stars(p){
    if(p.rating==null||p.rating===''||isNaN(parseFloat(p.rating)))return '<span>NEW: NO REVIEWS YET</span>';
    var r=parseFloat(p.rating), full=Math.round(r), s='';
    for(var i=1;i<=5;i++)s+=i<=full?'\u2605':'\u2606';
    var c=parseInt(p.count,10)||0;
    return '<b>'+s+'</b>'+(c?'<i>'+c+'</i>':'');
  }
  var CUT_DEFAULT=root.dataset.rwCut||'Athletic Fitted';
  var FABRIC_DEFAULT=root.dataset.rwFabric||'Cotton blend';
  function pickOpt(p,re){var o=(p.opts||[]).filter(function(x){return re.test(x.name)});return o.length?o[0].values:null}
  function sizesText(vals){if(!vals||!vals.length)return'\u2014';return vals.length>2?vals[0]+' \u2013 '+vals[vals.length-1]:vals.join(' / ')}
  function fabricText(p){
    var v=pickOpt(p,/fabric|material|blend|cotton|style/i);
    if(!v){var rest=(p.opts||[]).filter(function(x){return !/size|colou?r/i.test(x.name)});v=rest.length?rest[0].values:null}
    if(v&&v.length){
      v=v.map(function(t){return t.replace(/\s*\[.*?\]\s*/g,'').trim()}).filter(function(t,i,a){return t&&a.indexOf(t)===i});
      if(v.length)return v.slice(0,3).join(' or ')+(v.length>3?' +'+(v.length-3):'');
    }
    var tagHit=(p.tags||[]).filter(function(x){return /^fabric:/i.test(x)});
    if(tagHit.length)return tagHit[0].replace(/^fabric:/i,'').trim();
    return FABRIC_DEFAULT;
  }
  function cutText(p){
    if(p.cut)return p.cut;
    var t=(p.tags||[]).filter(function(x){return /^cut:/i.test(x)});
    if(t.length)return t[0].replace(/^cut:/i,'').trim();
    if((p.tags||[]).some(function(x){return /fitted/i.test(x)}))return'Fitted';
    if((p.tags||[]).some(function(x){return /relaxed|classic/i.test(x)}))return'Classic Fitted';
    return CUT_DEFAULT;
  }
  function fillCallouts(p){
    root.querySelector('[data-rw-co="fabric"]').textContent=fabricText(p);
    root.querySelector('[data-rw-co="sizes"]').textContent=sizesText(pickOpt(p,/size/i));
    root.querySelector('[data-rw-co="promise"]').textContent='Easy returns & exchanges';
    root.querySelector('[data-rw-co="cut"]').textContent=cutText(p);
  }
  function fillPanel(p){
    fillCallouts(p);
    panel.querySelector('[data-rw-title]').textContent=p.title;
    panel.querySelector('[data-rw-stars]').innerHTML=stars(p);
    panel.querySelector('[data-rw-price]').innerHTML=p.price+(p.compare?'<s>'+p.compare+'</s>':'');
    panel.classList.add('is-ready');
  }
  function hsl2hex(h,s,l){
    var c=(1-Math.abs(2*l-1))*s,x=c*(1-Math.abs((h/60)%2-1)),m=l-c/2,r=0,g=0,b=0;
    if(h<60){r=c;g=x}else if(h<120){r=x;g=c}else if(h<180){g=c;b=x}else if(h<240){g=x;b=c}else if(h<300){r=x;b=c}else{r=c;b=x}
    var to=function(v){return('0'+Math.round((v+m)*255).toString(16)).slice(-2)};
    return '#'+to(r)+to(g)+to(b);
  }
  function artColor(p,d,n,vis){
    var bins={},tot=0,i,o,k,b;
    for(i=0;i<n;i+=3){
      if(vis[i])continue; o=i*4; if(d[o+3]<200)continue;
      var r=d[o],g=d[o+1],bl=d[o+2],mx=Math.max(r,g,bl),mn=Math.min(r,g,bl); tot++;
      if(mx<45||(mx-mn)<40){k='k'}else{k=((r>>6)<<4)|((g>>6)<<2)|(bl>>6)}
      b=bins[k]; if(!b){b=bins[k]={c:0,r:0,g:0,b:0};} b.c++;b.r+=r;b.g+=g;b.b+=bl;
    }
    var arr=[];for(k in bins){if(k!=='k')arr.push(bins[k])}
    if(!arr.length||!tot)return;
    arr.sort(function(a,b){return b.c-a.c});
    var pick=arr[0];
    if(pick.c>tot*0.45&&arr[1])pick=arr[1];
    if(pick.c<tot*0.004)return;
    var R=pick.r/pick.c/255,G=pick.g/pick.c/255,B=pick.b/pick.c/255;
    var MX=Math.max(R,G,B),MN=Math.min(R,G,B),L=(MX+MN)/2,S=MX===MN?0:(MX-MN)/(1-Math.abs(2*L-1)),H;
    if(MX===MN)H=0;else if(MX===R)H=((G-B)/(MX-MN))%6;else if(MX===G)H=(B-R)/(MX-MN)+2;else H=(R-G)/(MX-MN)+4;
    H=(H*60+360)%360;
    if(L>0.62){p._light=true;p._color=hsl2hex(H,Math.min(S,0.45),0.88)}
    else{p._light=false;p._color=hsl2hex(H,Math.max(0.5,Math.min(0.95,S)),Math.max(0.30,Math.min(0.48,L)))}
  }
  /* Dominant art colour, sampled straight from the (pre-cut, alpha) slot image. Transparent pixels are skipped, so
     the pick is the design's hue, never the stage. Mirrors artColor's light/dark split so pale designs still get the
     pastel zoom background instead of a dark one. */
  function dominant(img,p){
    if(p._color)return p._color;
    var color='#B01C2E';
    try{
      var c0=p._cors; if(!c0||c0.src!==img.src){c0=new Image();c0.crossOrigin='anonymous';c0.src=img.src;p._cors=c0}
      img=c0;
      if(img.complete&&img.naturalWidth){
        var S=56,c=document.createElement('canvas');c.width=c.height=S;
        var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(img,0,0,S,S);
        var d=x.getImageData(0,0,S,S).data,B=[],i,opq=0,lumSum=0;
        for(i=0;i<24;i++)B.push({w:0,r:0,g:0,b:0});
        for(i=0;i<d.length;i+=4){
          var r=d[i],g=d[i+1],b=d[i+2],a=d[i+3]; if(a<128)continue;
          var mx=Math.max(r,g,b),mn=Math.min(r,g,b),sat=mx-mn;
          opq++; lumSum+=(mx+mn)/510;
          if(mn>225)continue;
          if(mx<45)continue;
          if(sat<38)continue;
          var h;
          if(mx===r)h=((g-b)/sat)%6;else if(mx===g)h=(b-r)/sat+2;else h=(r-g)/sat+4;
          h=(h*60+360)%360;
          var bk=B[Math.floor(h/15)%24],w=sat/255; bk.w+=w;bk.r+=r*w;bk.g+=g*w;bk.b+=b*w;
        }
        var best=B[0];for(i=1;i<24;i++)if(B[i].w>best.w)best=B[i];
        var light=opq>0&&(lumSum/opq)>0.62;
        if(best.w>0){
          var R=best.r/best.w/255,G=best.g/best.w/255,Bl=best.b/best.w/255;
          var MX=Math.max(R,G,Bl),MN=Math.min(R,G,Bl),L=(MX+MN)/2,Sv=MX===MN?0:(MX-MN)/(1-Math.abs(2*L-1)),H;
          if(MX===MN)H=0;else if(MX===R)H=((G-Bl)/(MX-MN))%6;else if(MX===G)H=(Bl-R)/(MX-MN)+2;else H=(R-G)/(MX-MN)+4;
          H=(H*60+360)%360;
          color=light?hsl2hex(H,Math.min(Sv,0.45),0.88):hsl2hex(H,Math.max(0.55,Math.min(0.95,Sv)),Math.max(0.30,Math.min(0.46,L)));
        }
        if(p._light===undefined)p._light=light&&best.w>0;
      }
    }catch(e){}
    if(p._cors&&!(p._cors.complete&&p._cors.naturalWidth))return color;
    p._color=color; return color;
  }
  function zoom(){
    if(mode!=='idle'||dragging||paused)return;
    var hero=slots[mod(Math.round(pos),SLOTS)], p=data[hero._idx];
    fillPanel(p);
    var bgc=p.bs3?(p.bg||'#1A1A1A'):dominant(hero.img,p);
    if(p.bs3)p._light=false;
    root.style.setProperty('--rw-bg',bgc); root.style.backgroundColor=bgc;
    root.classList.toggle('is-light',!!p._light);
    root.classList.toggle('is-bs3',!!p.bs3);
    paused=true;
    root.classList.remove('is-dwelling'); root.classList.add('is-zoomed'); hero.classList.add('is-hero');
    hero.style.transition='transform .65s cubic-bezier(.2,.8,.2,1)';
    hero.style.transform='translate3d(0px,0px,90px) rotateY(0deg) rotateZ(0deg) scale(1)';
    stage.setAttribute('aria-label',p.title+', '+p.price+'. Swipe to keep browsing.');
    loadProduct(p);
  }
  function unzoom(){
    clearDwell();
    if(!root.classList.contains('is-zoomed'))return;
    root.classList.remove('is-zoomed'); root.classList.remove('is-light'); root.classList.remove('is-bs3'); root.style.backgroundColor='';
    slots.forEach(function(s){s.classList.remove('is-hero');s.style.transition=''});
    paused=false; clearProduct();
  }
  function goTo(v){spun=true;unzoom();target=v;mode='snap';vel=0}
  stage.addEventListener('pointerdown',function(e){
    if(e.button&&e.button!==0)return;
    dragging=true;moved=false;downX=e.clientX;downY=e.clientY;vel=0;samples=[];
    downSlot=e.target.closest?e.target.closest('.rw-spin__slot'):null;
    stage.classList.add('is-dragging'); try{stage.setPointerCapture(e.pointerId)}catch(err){}
    if(!root.classList.contains('is-zoomed'))clearDwell();
    samples.push({t:performance.now(),p:pos});
  });
  stage.addEventListener('pointermove',function(e){
    if(!dragging)return;
    var dx=e.clientX-downX, dy=e.clientY-downY;
    if(!moved&&Math.abs(dx)<6&&Math.abs(dy)<6)return;
    if(!moved&&Math.abs(dy)>Math.abs(dx)*1.4){dragging=false;stage.classList.remove('is-dragging');if(mode==='idle'&&!paused)startDwell();return}
    if(!moved&&root.classList.contains('is-zoomed'))unzoom();
    moved=true;
    pos-=(e.clientX-(this._lx==null?downX:this._lx))/spacing; this._lx=e.clientX;
    samples.push({t:performance.now(),p:pos}); if(samples.length>12)samples.shift();
  });
  function up(e){
    if(!dragging){stage._lx=null;return}
    dragging=false;stage._lx=null;stage.classList.remove('is-dragging');
    if(!moved){
      if(root.classList.contains('is-zoomed'))unzoom();
      if(downSlot&&downSlot._v!=null&&downSlot._v!==Math.round(pos))goTo(downSlot._v);
      else{target=Math.round(pos);mode='snap'}
      return;
    }
    var now=performance.now(),s=null,i;
    for(i=samples.length-1;i>=0;i--){s=samples[i];if(now-s.t>=90)break}
    var dt=s?(now-s.t)/1000:0;
    vel=dt>0.016?(pos-s.p)/dt:0;
    vel=Math.max(-MAXV,Math.min(MAXV,vel));
    spun=true; flingStart=pos; mode='free';
  }
  stage.addEventListener('pointerup',up); stage.addEventListener('pointercancel',up);
  stage.addEventListener('lostpointercapture',function(){if(dragging)up()});
  stage.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight'){goTo(Math.round(pos)+1);e.preventDefault()}
    else if(e.key==='ArrowLeft'){goTo(Math.round(pos)-1);e.preventDefault()}
    else if(e.key==='Enter'&&mode==='idle'&&!paused){clearDwell();zoom();e.preventDefault()}
    else if(e.key==='Escape')unzoom();
  });
  window.addEventListener('resize',function(){measure();if(paused){var h=root.querySelector('.is-hero');if(h){h.style.transform='translate3d(0px,0px,90px) rotateY(0deg) rotateZ(0deg) scale(1)'}}});
  document.addEventListener('visibilitychange',function(){if(document.hidden)clearDwell();else if(mode==='idle'&&!paused)startDwell()});
  /* ---- product page reveal below the zoomed tee ---- */
  var prodHost=root.querySelector('[data-rw-product]'), prodInner=root.querySelector('[data-rw-product-inner]'), prodFor=null;
  function runScripts(container){
    var scripts=container.querySelectorAll('script'); for(var i=0;i<scripts.length;i++){
      var o=scripts[i], n=document.createElement('script');
      for(var a=0;a<o.attributes.length;a++)n.setAttribute(o.attributes[a].name,o.attributes[a].value);
      if(o.src){ if(document.querySelector('script[src="'+o.getAttribute('src')+'"]'))continue; }
      else n.textContent=o.textContent;
      o.parentNode.replaceChild(n,o);
    }
  }
  var SEC_ID=null;
  function liftSection(pageHtml){
    var m=pageHtml.match(/id="shopify-section-(template--\d+__main-product)"/); if(m)SEC_ID=m[1];
    try{var doc=new DOMParser().parseFromString(pageHtml,'text/html');var el=doc.getElementById('shopify-section-'+(SEC_ID||'main-product'));return el?el.outerHTML:null}catch(e){return null}
  }
  var LTD_TIMER=null;
  function startLtdClock(cells){
    if(LTD_TIMER){clearInterval(LTD_TIMER);LTD_TIMER=null}
    var days=parseFloat(root.dataset.rwLtdDays||'14'); if(!(days>0))days=14;
    var span=days*86400000, key='rwLtdEnd', end=0;
    try{end=parseInt(window.localStorage.getItem(key),10)||0}catch(e){end=0}
    var now=Date.now();
    if(!end||end<=now){end=now+span;try{window.localStorage.setItem(key,String(end))}catch(e){}}
    function pad(v){return (v<10?'0':'')+v}
    function tick(){
      var left=end-Date.now();
      if(left<=0){
        end=Date.now()+span; try{window.localStorage.setItem(key,String(end))}catch(e){}
        left=span;
      }
      var sec=Math.floor(left/1000);
      cells.d.textContent=pad(Math.floor(sec/86400));
      cells.h.textContent=pad(Math.floor(sec%86400/3600));
      cells.m.textContent=pad(Math.floor(sec%3600/60));
      cells.s.textContent=pad(sec%60);
    }
    tick(); LTD_TIMER=setInterval(tick,1000);
  }
  function enableSwipe(container){
    try{
      var lists=container.querySelectorAll('.product__media-list');
      for(var i=0;i<lists.length;i++){
        var mlist=lists[i];
        mlist.style.cssText+=';overflow-x:auto;-webkit-overflow-scrolling:touch;touch-action:pan-x;scroll-snap-type:x mandatory;flex-wrap:nowrap';
        var kids=mlist.children;
        for(var gi=0;gi<kids.length;gi++)kids[gi].style.scrollSnapAlign='center';
      }
    }catch(e){}
  }
  function loadProduct(p){
    if(prodFor===p&&prodInner.children.length)return;
    prodFor=p; prodInner.innerHTML='<div class="rw-spin__ploading">Loading '+p.title+'&hellip;</div>';
    var render=function(html){
      if(prodFor!==p)return;
      html=html.replace(/\sdata-animate="[^"]*"/g,'').replace(/\sdata-immediate(?=[\s>])/g,'').replace(/\bjs-invisible\b/g,'');
      prodInner.innerHTML=html;
      var sf=prodInner.querySelector('product-sticky-form'); if(sf)sf.remove();
      var pi=prodInner.querySelector('product-info');
      if(pi)pi.style.cssText+=';opacity:1!important;visibility:visible!important;transform:none!important';
      var tg2=(p.tags||[]).map(function(t){return String(t).toLowerCase()});
      if(tg2.indexOf('ltd')>-1){
        var band=document.createElement('div'); band.className='rw-spin__ltd-banner';
        var bhead=document.createElement('em'); bhead.textContent=(root.dataset.rwLtdHead||'8,388+ 5 Star Brand Reviews');
        var bmain=document.createElement('b'); bmain.textContent='Limited Time Design';
        band.appendChild(bhead); band.appendChild(bmain);
        var rule=document.createElement('span'); rule.className='rw-spin__ltd-rule'; band.appendChild(rule);
        var clock=document.createElement('div'); clock.className='rw-spin__ltd-clock';
        var cells={}, units=[['d','Days'],['h','Hrs'],['m','Min'],['s','Sec']];
        units.forEach(function(u){
          var cell=document.createElement('span');
          var num=document.createElement('i'); var lab=document.createElement('u'); lab.textContent=u[1];
          cell.appendChild(num); cell.appendChild(lab); clock.appendChild(cell); cells[u[0]]=num;
        });
        band.appendChild(clock);
        startLtdClock(cells);
        var sec2=prodInner.querySelector('.shopify-section')||prodInner.firstElementChild;
        var host=(sec2&&sec2.querySelector('.page-width'))||sec2||prodInner;
        host.insertBefore(band,host.firstChild);
      }
      enableSwipe(prodInner);
      runScripts(prodInner);
      var sec=prodInner.querySelector('.shopify-section')||prodInner.firstElementChild||prodInner;
      var boot=function(){
        try{sec.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true,detail:{sectionId:SEC_ID||'main-product'}}))}catch(e){}
        try{if(window.jdgm&&typeof jdgm.customizeBadges==='function')jdgm.customizeBadges()}catch(e){}
        try{if(window.jdgm&&typeof jdgm.initPreviewBadges==='function')jdgm.initPreviewBadges()}catch(e){}
        enableSwipe(prodInner);
      };
      if(document.readyState==='complete')setTimeout(boot,0);else window.addEventListener('load',boot,{once:true});
      setTimeout(function(){
        var pi2=prodInner.querySelector('product-info');
        var msg='section '+(SEC_ID||'main-product')+' \u00b7 product-info '+(pi2?('found, '+pi2.children.length+' blocks, '+pi2.getBoundingClientRect().height.toFixed(0)+'px tall, opacity '+getComputedStyle(pi2).opacity):'MISSING ('+html.length+' chars)');
        dbg(msg); if(window.console)console.log('[rw-spin] '+msg);
      },1200);
      document.dispatchEvent(new CustomEvent('rw:product-loaded',{detail:{url:p.url}}));
    };
    var fail=function(){if(prodFor===p)prodInner.innerHTML='<div class="rw-spin__ploading"><a href="'+p.url+'">Open product page</a></div>'};
    if(p._html){render(p._html);return}
    if(!window.fetch){fail();return}
    var req=SEC_ID?fetch(p.url+(p.url.indexOf('?')>-1?'&':'?')+'section_id='+encodeURIComponent(SEC_ID),{credentials:'same-origin'}).then(function(r){return r.ok?r.text():Promise.reject(r.status)})
                 :fetch(p.url,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():Promise.reject(r.status)}).then(function(page){var h=liftSection(page);if(!h)throw new Error('no section');return h});
    req.then(function(html){
      if(!/<product-info[\s\S]{200,}/.test(html)){
        return fetch(p.url,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(page){var h=liftSection(page);if(!h)throw new Error('no section');return h});
      }
      return html;
    }).then(function(html){p._html=html;render(html)}).catch(function(e){dbg('product load failed: '+(e&&e.message||e));fail()});
  }
  function clearProduct(){prodFor=null;prodHost.classList.remove('is-in');prodInner.innerHTML='';if(LTD_TIMER){clearInterval(LTD_TIMER);LTD_TIMER=null}}
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting&&root.classList.contains('is-zoomed'))prodHost.classList.add('is-in')})},{threshold:0.12}).observe(prodHost);
  }else{prodHost.classList.add('is-in')}
  /* ---- bundle tracker: mirrors the cart ----
     A cart line counts for the number of SHIRTS it contains, not the number of lines. The Best Seller 3 Pack is a
     single line holding three shirts, so it is weighted BS3_UNITS — without that, a customer who buys the pack sees
     one tee lit out of five and concludes they have unlocked nothing, when they have in fact cleared the 3 for $69
     tier. Everything else counts by product type as before. */
  var bundle=root.querySelector('[data-rw-bundle]'), lastCount=-1;
  function isTee(it){var t=(it.product_type||'').toLowerCase();return t==='shirt'||t==='shirts'||t==='tee'||t==='t-shirt'}
  function teeUnits(it){
    var q=it.quantity||0;
    var h=String(it.handle||'').toLowerCase();
    if(h===BS3_HANDLE)return q*BS3_UNITS;
    return isTee(it)?q:0;
  }
  function paintBundle(n){
    if(n===lastCount)return; lastCount=n; bundle.dataset.count=n;
    bundle.querySelector('[data-rw-fill]').style.width=Math.max(0,Math.min(100,(n-1)*25))+'%';
    var tees=bundle.querySelectorAll('.rw-spin__tee');
    for(var i=0;i<tees.length;i++){var k=i+1;tees[i].classList.toggle('is-on',n>=k);
      if(tees[i].classList.contains('rw-spin__tee--goal'))tees[i].classList.toggle('is-unlocked',n>=k)}
    /* status line above the tee icons retired 2026-09-17 (kept in the DOM for screen readers, hidden visually) */
    var st=bundle.querySelector('[data-rw-bstatus]'); st.style.display='none';
    st.textContent=n>=5?'5 in cart \u00b7 $100 bundle unlocked':n>=3?n+' in cart \u00b7 $69 unlocked \u00b7 '+(5-n)+' more for $20 tees':n===0?'Add 3 tees for $69 \u00b7 5 for $100':n+' in cart \u00b7 '+(3-n)+' more unlocks $69';
  }
  function readCart(){
    if(!window.fetch)return;
    fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.ok?r.json():null}).then(function(c){
      if(!c||!c.items)return; var n=0; c.items.forEach(function(it){n+=teeUnits(it)}); paintBundle(n);
    }).catch(function(){});
  }
  paintBundle(parseInt(bundle.dataset.count,10)||0);
  readCart(); setInterval(function(){if(!document.hidden)readCart()},4000);
  window.addEventListener('focus',readCart); document.addEventListener('cart:updated',readCart); document.addEventListener('cart:refresh',readCart);
  if(window.fetch){var _f=window.fetch;window.fetch=function(u,o){var pr=_f.apply(this,arguments);try{if(typeof u==='string'&&/\/cart\/(add|change|update|clear)/.test(u))pr.then(function(){setTimeout(readCart,250)})}catch(e){}return pr}}
  /* ---- load every remaining tee in the collection (mirrors infinite scroll) ---- */
  function loadAllPages(){
    var total=parseInt(root.dataset.rwTotal,10)||N;
    var per=parseInt(root.dataset.rwPerPage,10)||N;
    if(!window.fetch||total<=N||per<=0)return;
    var pages=Math.ceil(total/per);
    var wrap=root.closest('[id^="shopify-section-"]');
    if(!wrap)return;
    var secId=wrap.id.replace('shopify-section-','');
    var colUrl=root.dataset.rwColUrl||location.pathname;
    /* keyed by handle (url as fallback) so the pinned BS3Pack item blocks its own collection duplicate */
    var seen={}; data.forEach(function(d){seen[d.handle||d.url]=1});
    var p=2;
    function next(){
      if(p>pages)return;
      fetch(colUrl+(colUrl.indexOf('?')>-1?'&':'?')+'section_id='+encodeURIComponent(secId)+'&page='+p,{credentials:'same-origin'})
        .then(function(r){return r.ok?r.text():Promise.reject(r.status)})
        .then(function(html){
          var m=html.match(/<script[^>]*data-rw-products[^>]*>([\s\S]*?)<\/script>/);
          if(m){
            try{
              var arr=JSON.parse(m[1]).filter(function(x){return x&&x.img&&!x.bs3});
              arr.forEach(function(x){var kk=x.handle||x.url;if(!seen[kk]){seen[kk]=1;data.push(x)}});
              N=data.length;
            }catch(e){dbg('page '+p+' parse failed: '+(e&&e.message||e))}
          }
        })
        .catch(function(e){dbg('page '+p+' fetch failed: '+(e&&e.message||e))})
        .then(function(){p++;next()});
    }
    next();
  }
  measure(); render(performance.now()); requestAnimationFrame(frame);
  loadAllPages();
})();